import Head from "next/head";

export default function JsonLdBlog({ data }) {

  const { title, date, slug } = data;
  const image = data?.featuredImage?.node?.sourceUrl || '';
  const { name, avatar } = data.author.node
  const url = `${process.env.NEXTAUTH_URL}/blog/${slug}`;
  const articleStructuredData = {
    "@context": "http://schema.org",
    "@type": "BlogPosting",
    headline: title,
    datePublished: date,
    image: image,
    author: {
      "@type": "Person",
      name: name,
      url: avatar.url
    },
    "breadcrumb": {
      "@context": "http://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
          "item": url,
          "name": title,
        
      }]
    }
  };
  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(articleStructuredData),
        }}
      />
    </Head>
  );
}
